import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.isOpen = false;
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.menuTarget.classList.remove("hidden", "opacity-0", "scale-95");
    this.menuTarget.classList.add("opacity-100", "scale-100");
  }

  close() {
    this.isOpen = false;
    this.menuTarget.classList.add("opacity-0", "scale-95");
    this.menuTarget.classList.remove("opacity-100", "scale-100");
    setTimeout(() => {
      if (!this.isOpen) {
        this.menuTarget.classList.add("hidden");
      }
    }, 150);
  }

  hide(event) {
    if (!this.element.contains(event.target) && this.isOpen) {
      this.close();
    }
  }
}
